import { SvgIcon, SvgIconBaseProps } from '@honeycomb/ui-core';
import * as React from 'react';

export function WhatsAppIcon(props: SvgIconBaseProps): React.JSX.Element {
    return (
        <SvgIcon {...props} viewBox="0 0 35.1 35.1">
            <path
                d="M5 0h25.1c2.8 0 5 2.2 5 5v25.1c0 2.8-2.2 5-5 5H5c-2.8 0-5-2.2-5-5V5c0-2.8 2.2-5 5-5"
                fillRule="evenodd"
                clipRule="evenodd"
                fill="#189c0e"
            />
            <path
                fill="fbfdfb"
                d="M5 30.1c.4-1.3.7-2.6 1-3.8l.6-2.1c.1-.4.1-.7-.1-1.1-3.7-7.5.8-16.5 9.1-17.9C22.4 4 28.9 8.8 29.9 15.5c1 6.9-3.6 13.2-10.4 14.3-2.5.4-4.9.1-7.1-1-.4-.2-.8-.2-1.2-.1-2 .5-3.9.9-5.9 1.4H5zm3.1-2.9c1.1-.3 2.2-.5 3.2-.8.4-.1.7-.1 1.1.1 2 1.1 4.1 1.6 6.3 1.3 4.9-.5 8.9-4.6 9.3-9.6.5-6.7-5.2-12-11.8-11.1-7.3 1-11.3 9-7.7 15.4.4.6.4 1.3.2 2-.3.9-.5 1.8-.6 2.7-.1-.1-.1 0-.1 0h.1z"
            />
            <path d="M8.1 27.2H8h.1z" fill="#199d0f" />
            <path
                fill="fbfdfb"
                d="M11.3 14.5c0-.7.3-1.5 1-2.3.4-.4.9-.6 1.5-.5.3 0 .5.2.7.5.3.8.6 1.6 1 2.3.1.3.1.5-.1.7-.1.1-.1.2-.2.4-.8.9-.8.7 0 1.9.9 1.4 2.2 2.3 3.7 3 .4.2.7.1 1-.3.2-.3.5-.6.7-.9.2-.3.5-.4.9-.2.8.4 1.5.7 2.3 1.1.3.1.4.4.4.7-.2 1.6-1.5 2.7-3.1 2.5-3.2-.3-5.5-2.1-7.5-4.5-.6-.7-1.2-1.6-1.6-2.4-.6-.5-.7-1.1-.7-2z"
            />
        </SvgIcon>
    );
}
